import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";

import { useAppContext } from "../../config/AppContext.js";

import { Spin } from "antd";
import Icon1 from "../../icons/Icon.js";
import { queryCollection } from "../../models/DataFunctions.js";
const MasterSmallStats = ({ navigateWorkspace, userData, orgData, handleClickVariant }) => {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  let saved_data = appState.saved_data;
  const [partners, setPartners] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [dict_stats, setDict_stats] = useState({});
  // Function to fetch user and organization data
  const handleFetchData = async () => {
    try {
      setLoaded(true);
      // const partners = await queryCollection("org", [
      //   {
      //     field: "masters_id",
      //     operator: "array-contains",
      //     value: userData.org_id,
      //   },
      // ]);
      // setPartners(partners);

      // Set the fetched user and organization data in state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (orgData && userData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [userData, orgData]); // Re-run when currentUser changes

  // Display loading message while checking authentication or fetching user data
  // If the data is still loading, show skeletons
  // loading || !currentUser || !userData
  if (loading || !currentUser || !userData || !orgData) {
    return <></>;
  }

  if (loaded === false) {
    return (
      <div className="flex flex-col w-fit h-fit  ">
        <Spin size="medium" />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-fit h-fit  ">
      {" "}
      <div className="flex flex-wrap gap-2 max-w-c1p2k mt-4">
        <BlockNumer
          icon="logement"
          fill="black"
          title="Carnets"
          onClick={() => navigateWorkspace("/carnets")}
          number={(appState.carnets || []).length}
        />
        {/* <BlockNumer
          icon="user"
          fill="black"
          title="Partenaires"
          onClick={() => navigateWorkspace("/partners")}
          number={partners.length}
        />{" "} */}
        {orgData?.logement?.access?.can_create === true && (
          <BlockNumer
            icon="card"
            fill="black"
            title="Crédits restants"
            onClick={() => {handleClickVariant("Contactez le support pour recharger vos crédits", "info")}}
            number={orgData?.logement?.facturation?.credits || 0}
          />
        )}
      </div>
    </div>
  );
};

export default MasterSmallStats;

export const BlockNumer = ({
  title,
  number,
  icon = "folder",
  fill = "black",
  textclassname = "",
  onClick = () => {},
}) => {
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl cursor-pointer  hover:shadow-lg hover:shadow-blue-100 p-4 flex flex-col shadow-md shadow-blue-100 w-c200   border-blue-100"
    >
      <Icon1 icon_name={icon} size={20} fill={fill}></Icon1>{" "}
      <div
        className={` text-hx2 font-semibold text-black flex flex-row mt-4  ${textclassname}`}
      >
        {number}
      </div>
      <div className=" text-h3 flex flex-row   ">{title}</div>
    </div>
  );
};
